export const TEMP_CACHE = new Map<any, any>();
